// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mantiene el estilo existente */
.portraits-container {
  display: grid;
  grid-template-columns: repeat(6, 1fr); /* 6 columnas fijas */
  gap: 10px; /* Espacio entre imágenes */
  padding: 10px;
  margin: 0.4cm;
}

.image-wrapper {
  position: relative;
  width: 100%; /* Ocupa todo el ancho de la columna */
  height: 100%; /* Altura fija para las imágenes */
  overflow: hidden; /* Esconde cualquier desbordamiento de la imagen */
}

.thumbnail {
  width: 100%;
  height: 100%;
  object-fit: contain; /* Mantiene la proporción de la imagen */
  object-position: top; /* Alinea la imagen desde la parte superior */
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.7s ease-in-out, transform 0.7s ease-in-out;
}

.thumbnail.appear {
  opacity: 1;
  transform: translateY(0);
}

.enlarged-image {
  max-width: 90%;
  max-height: 90%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  transition: transform 0.5s ease-in-out;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Mobile version */
@media (max-width: 768px) {
  .portraits-container {
    grid-template-columns: 1fr; /* Cambia a 1 columna en móviles */
    gap: 5px; /* Espacio más pequeño entre imágenes */
    padding: 5px;
    margin: 0.2cm;
  }

  .image-wrapper {
    width: 100%; /* Mantiene el 100% del ancho de la columna */
    height: auto; /* Ajusta la altura automáticamente */
  }

  .thumbnail {
    width: 100%; /* Mantiene el 100% del ancho en móviles */
    height: auto; /* Ajusta la altura automáticamente */
  }

  .enlarged-image {
    max-width: 95%; /* Ajusta el ancho máximo en móviles */
    max-height: 85%; /* Ajusta el alto máximo en móviles */
  }

  .gallery-header {
    margin-bottom: 10px; /* Reduce el margen inferior en móviles */
  }

  .gallery-title {
    font-size: 2rem; /* Ajusta el tamaño de la fuente del título */
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Portraits.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,aAAa;EACb,qCAAqC,EAAE,qBAAqB;EAC5D,SAAS,EAAE,2BAA2B;EACtC,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,sCAAsC;EACnD,YAAY,EAAE,kCAAkC;EAChD,gBAAgB,EAAE,kDAAkD;AACtE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAE,wCAAwC;EAC7D,oBAAoB,EAAE,6CAA6C;EACnE,UAAU;EACV,2BAA2B;EAC3B,gEAAgE;AAClE;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE;IACE,0BAA0B,EAAE,kCAAkC;IAC9D,QAAQ,EAAE,uCAAuC;IACjD,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW,EAAE,6CAA6C;IAC1D,YAAY,EAAE,qCAAqC;EACrD;;EAEA;IACE,WAAW,EAAE,0CAA0C;IACvD,YAAY,EAAE,qCAAqC;EACrD;;EAEA;IACE,cAAc,EAAE,sCAAsC;IACtD,eAAe,EAAE,qCAAqC;EACxD;;EAEA;IACE,mBAAmB,EAAE,yCAAyC;EAChE;;EAEA;IACE,eAAe,EAAE,6CAA6C;EAChE;AACF","sourcesContent":["/* Mantiene el estilo existente */\n.portraits-container {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr); /* 6 columnas fijas */\n  gap: 10px; /* Espacio entre imágenes */\n  padding: 10px;\n  margin: 0.4cm;\n}\n\n.image-wrapper {\n  position: relative;\n  width: 100%; /* Ocupa todo el ancho de la columna */\n  height: 100%; /* Altura fija para las imágenes */\n  overflow: hidden; /* Esconde cualquier desbordamiento de la imagen */\n}\n\n.thumbnail {\n  width: 100%;\n  height: 100%;\n  object-fit: contain; /* Mantiene la proporción de la imagen */\n  object-position: top; /* Alinea la imagen desde la parte superior */\n  opacity: 0;\n  transform: translateY(20px);\n  transition: opacity 0.7s ease-in-out, transform 0.7s ease-in-out;\n}\n\n.thumbnail.appear {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.enlarged-image {\n  max-width: 90%;\n  max-height: 90%;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1000;\n  transition: transform 0.5s ease-in-out;\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Mobile version */\n@media (max-width: 768px) {\n  .portraits-container {\n    grid-template-columns: 1fr; /* Cambia a 1 columna en móviles */\n    gap: 5px; /* Espacio más pequeño entre imágenes */\n    padding: 5px;\n    margin: 0.2cm;\n  }\n\n  .image-wrapper {\n    width: 100%; /* Mantiene el 100% del ancho de la columna */\n    height: auto; /* Ajusta la altura automáticamente */\n  }\n\n  .thumbnail {\n    width: 100%; /* Mantiene el 100% del ancho en móviles */\n    height: auto; /* Ajusta la altura automáticamente */\n  }\n\n  .enlarged-image {\n    max-width: 95%; /* Ajusta el ancho máximo en móviles */\n    max-height: 85%; /* Ajusta el alto máximo en móviles */\n  }\n\n  .gallery-header {\n    margin-bottom: 10px; /* Reduce el margen inferior en móviles */\n  }\n\n  .gallery-title {\n    font-size: 2rem; /* Ajusta el tamaño de la fuente del título */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
